/* import __COLOCATED_TEMPLATE__ from './fullscreen-button.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class FullscreenButtonComponent extends Component 
{
	@service fullscreen;
	
	@action toggleFullscreen()
	{
		this.fullscreen.toggle();
	}
}